import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";
import { Identifiable, ProjectResource, projectResource } from "@planzone/dto";

function createInteractor(repository: Repository): Interactor {
  return ({ project, resources, role }) =>
    present(
      repository
        .saveResourcesInProject(resources, project, role)
        .then((projectResources) => ({
          resources,
          project,
          role,
          projectResources,
        }))
        .catch(() => Promise.reject({ resources, project, role })),
    );
}

export type { Interactor };

export { createInteractor };
